import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface LikeToneResponse extends APIResponse
{

}

export class LikeToneResponseDtoImpl extends APIResponseDtoImpl implements LikeToneResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/liketune/liketoneresponse.tsx